var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 18.9311C4 14.8148 4 10.702 4 6.58576C4.01365 6.48267 4.0273 6.37959 4.04436 6.27295C4.31736 4.37121 5.82227 3.00622 7.67184 3.00267C10.5588 2.99911 13.4492 2.99911 16.3362 3.00267C16.5409 3.00267 16.7457 3.01333 16.947 3.05243C18.742 3.39012 19.9875 4.90441 19.9944 6.80259C20.0046 10.7696 19.9978 14.7366 19.9978 18.7C19.9978 19.0661 19.9261 19.4145 19.7691 19.7451C19.1071 21.1314 17.3429 21.43 16.2747 20.328C14.8961 18.9062 13.5243 17.4772 12.1456 16.0518C12.0978 16.002 12.0501 15.9594 12.0057 15.9132C11.9818 15.9309 11.9716 15.9381 11.9613 15.9452C11.1935 16.7414 10.4257 17.5376 9.65792 18.3339C8.99248 19.0199 8.34411 19.7238 7.66161 20.392C6.50818 21.5224 4.60742 21.0034 4.11944 19.4394C4.06825 19.2759 4.03754 19.1017 4 18.9311Z",
    fill: "#347EF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiBadge);
export default __webpack_public_path__ + "static/media/ai-badge.4ec5ce30e7f9581f04dc7df90017638b.svg";
export { ForwardRef as ReactComponent };